import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { ChatState, ChatMessage } from '@models/index'

const initialState: ChatState = {
  messages: [],
  pendingQuery: '',
  loading: false,
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<ChatMessage>) => {
      state.messages.push(action.payload)
    },
    setPendingQuery: (state, action: PayloadAction<string>) => {
      state.pendingQuery = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    clearMessages: (state) => {
      state.messages = []
    },
  },
})

export const { addMessage, setPendingQuery, setLoading, clearMessages } = chatSlice.actions
export default chatSlice.reducer
